import React from 'react';
import { Box, Text, HStack } from '@chakra-ui/react';

interface PermissionAlertProps {
  isMobile: boolean;
}

const instructionsTexts = {
  mobile: 'Para iniciar, permita acesso ao microfone em:\nConfigurações -> Aplicativos -> Mevo -> Permissões.',
  desktop: 'Para iniciar, permita acesso ao microfone na sua barra do navegador.',
};

function PermissionAlert({ isMobile }: PermissionAlertProps) {
  return (
    <Box px="16px" pt="16px" pb="16px">
      <Box bg="yellow.100" borderRadius="12px" p="12px" border="1px solid" borderColor="yellow.200">
        <HStack spacing="8px" align={isMobile ? 'flex-start' : 'center'}>
          <Text fontSize="16px" color="yellow.600">
            ⚠️
          </Text>
          <Text fontWeight="bold" fontSize="14px" color="purple.600" flex="1" whiteSpace="pre-line">
            {isMobile ? instructionsTexts.mobile : instructionsTexts.desktop}
          </Text>
        </HStack>
      </Box>
    </Box>
  );
}

export { PermissionAlert };
